var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"goTop",on:{"click":function($event){return _vm.goTop()}}},[_c('i',{staticClass:"el-icon-arrow-up"})])}
var staticRenderFns = []

export { render, staticRenderFns }